import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのEquipmentロゴアイコン
 */
export function ProductLogoSmallEquipment({
  size = 20,
  color = "#25506B",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300 60C313.255 60 324 70.7452 324 84V204C324 217.255 313.255 228 300 228H180C166.745 228 156 217.255 156 204V84C156 70.7452 166.745 60 180 60H300ZM224 84C219.582 84 216 87.5817 216 92V112C216 116.418 219.582 120 224 120H256C260.418 120 264 116.418 264 112V92C264 87.5817 260.418 84 256 84H224Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M396 252C409.255 252 420 262.745 420 276V396C420 409.255 409.255 420 396 420H276C262.745 420 252 409.255 252 396V276C252 262.745 262.745 252 276 252H396ZM320 276C315.582 276 312 279.582 312 284V304C312 308.418 315.582 312 320 312H352C356.418 312 360 308.418 360 304V284C360 279.582 356.418 276 352 276H320Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204 252C217.255 252 228 262.745 228 276V396C228 409.255 217.255 420 204 420H84C70.7452 420 60 409.255 60 396V276C60 262.745 70.7452 252 84 252H204ZM128 276C123.582 276 120 279.582 120 284V304C120 308.418 123.582 312 128 312H160C164.418 312 168 308.418 168 304V284C168 279.582 164.418 276 160 276H128Z"
        fill={color}
      />
    </svg>
  );
}
